import { gql } from "@apollo/client";

/**
 * Detail zbernej faktury. Cita sa len vtedy, ked sa v zozname zakaziek klikne
 * na cislo zbernej faktury: ukaze sa, co na nej je, a da sa stiahnut alebo
 * poslat. Vlastna obrazovka na to nie je a ani nema byt.
 */
export const GET_INVOICE = gql`
  query getInvoice($tokenGet: String!, $id: ID!) {
    getInvoice(token: $tokenGet, id: $id) {
      id
      number
      type
      status
      issue_date
      due_date
      delivery_date
      period_from
      period_to
      payment_type
      customer_company
      total_netto
      total_vat
      total_gross
      sent_to_customer_at
      sent_to_accountant_at
      carOwner {
        id
        company
        invoice_emails
      }
      items {
        id
        serviceId
        licence_plate
        service_date
        name
        code
        qty
        unit
        price_netto
        vat_rate
        total_netto
        vat_amount
        total_gross
      }
    }
  }
`;
